import { writable } from "svelte/store";

export const result = writable({});
